import { Outlet } from 'react-router-dom';

import { Page, PageHeader } from '@/components';

import CallRecordsDataGrid from './components/CallRecordsDataGrid';

const CallRecordsList = () => {
  return (
    <Page title="Call log records">
      <PageHeader title="Call log records" />
      <CallRecordsDataGrid />
      <Outlet />
    </Page>
  );
};

export default CallRecordsList;
